import { HttpClient } from '@angular/common/http';
import { AfterContentChecked, Component, OnInit, ViewChild } from '@angular/core';
import { TabsetComponent } from 'ng-uikit-pro-standard';
import { BehaviorSubject, merge, Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { IStatViewModel } from 'src/app/share/entities/view-model';
import { IPageDataViewModel } from 'src/app/share/pages/pages';
import { AuthService } from 'src/app/share/services/auth.service';
import { CommonService } from 'src/app/share/services/common.service';

@Component({
  selector: 'app-web-applications',
  templateUrl: './web-applications.component.html',
  styleUrls: ['./web-applications.component.scss']
})
export class WebApplicationsComponent implements OnInit   {

  constructor(private commonService: CommonService, private authService: AuthService, private http: HttpClient) { }

  vm$: Observable<any>
  private cmd$ = new BehaviorSubject<IWebApplicationCommand>({ load: true });
  dataLoadCompleted: boolean = false;


  ngOnInit() {
    this.loadPage$();
  }

  loadPage$() {
    this.vm$ = this.cmd$.pipe(
      switchMap(cmd => {
        if (cmd.load) {
          return this.commonService.getData('PageCommand', 'web.application', 'page-load').pipe(
            map((v: IViewModelWebApplication) => {
              this.dataLoadCompleted = v.workingText ? false : true;
              if (v.workingText)
                return { ...v };

              const ret = { ...v, actionsAllowed: true };
              
              if (ret.data) {
                // stat panel 
                ret.statPanelVm = ret.data.statPanel ? {
                  data: ret.data.statPanel
                } : null;

                ret.panelsVm = [];
                if (ret.data.panels && !ret.data.panels[0].unauthorized) {
                  ret.data.panels.forEach(p => {
                    const retPanel: IWebApplicationDataPanelViewModel = {
                      data: p,
                      title: p.title,
                      type: p.type,
                      sections: p.sections,
                      sectionsFiltered: p.sections
                    };
                    ret.panelsVm.push(retPanel);
                  })
                }
              }
              return ret;
            })
          );
        } else {
          
          return merge(

            // prep
            of(cmd).pipe(
              map(cmd => {
                const ret = { ...cmd.viewModel, actionsAllowed: false };

                if (cmd.invokeMarkComplete || cmd.invokeWelcomeEmail || cmd.invokeNotifySalesTeam) {
                  ret.data.panels[cmd.panelId].sections.forEach(s => s.cmdExecutedErrorText = undefined);

                  const s = ret.data.panels[cmd.panelId].sections.find(s => s.webAccountApplicationId == cmd.id);
                  s.cmdExecutingText = 'Validating...';
                }
                return ret;
              })
            ),

            // invoke API
            of(cmd).pipe(

              // invoke server comand
              switchMap((cmd) => {

                if (cmd.invokeMarkComplete || cmd.invokeWelcomeEmail || cmd.invokeNotifySalesTeam)
                  return this.executeAction$(cmd);
                else
                  throw 'unknown command';
              })
            )
          );
        }
      })
    );
  }

  private executeAction$(cmd: IWebApplicationCommand): Observable<IViewModelWebApplication> { 
    return this.commonService.getData('PageCommand', 'web.application', cmd.actionName, { id: cmd.id }).pipe(
      map((r: IWebApplicationCommandResult) => {
        this.dataLoadCompleted = r.workingText ? false : true;
        if (r.workingText)
          return { ...cmd.viewModel, actionsAllowed: false };

        const ret: IViewModelWebApplication = { ...cmd.viewModel, actionsAllowed: true };

        const s = cmd.viewModel.panelsVm[cmd.panelId].sections.find(r => r.webAccountApplicationId == cmd.id);
        s.cmdExecutingText = undefined;
        s.cmdExecutedErrorText = r.errorText;

        if (cmd.actionName && r.data && r.data.status == 'ok') {
          switch(cmd.actionName) {
            case 'mark-completed':
              s.completedText = 'Marked as completed...';
              s.applicationStatus = 2;
              break;
            case 'welcome-email':
              s.completedText = 'Welcome email sent...';
              s.sendWelcomeEmail = false;
              break;
            case 'notify-sales':
              s.completedText = 'Email email sent to sales team...';
              s.sendSalesTeamEmail = false;
              break;
          }
        } else {
          s.completedText = undefined;
        }

        return ret;
      }),
      catchError((e, v) => {
        const ret = { ...cmd.viewModel };

        const s = cmd.viewModel.panelsVm[cmd.panelId].sections.find(r => r.webAccountApplicationId == cmd.id);
        s.cmdExecutingText = undefined;
        s.cmdExecutedErrorText = e || 'unkown error';

        return of(ret);
      })
    );
  }


  /**
   * 
   */
  refreshPage() {
    this.cmd$.next({ load: true });
    this.authService.userInRole;
  }

  markCompleted(vm: IViewModelWebApplication, id: number, panelId: number) {
    this.cmd$.next({ invokeMarkComplete: { }, actionName: 'mark-completed', id: id, viewModel: vm, panelId: panelId });
  }
  welcomeEmail(vm: IViewModelWebApplication, id: number, panelId: number) {
    this.cmd$.next({ invokeWelcomeEmail: { }, actionName: 'welcome-email', id: id, viewModel: vm, panelId: panelId });
  }

  notifySalesTeam(vm: IViewModelWebApplication, id: number, panelId: number) {
    this.cmd$.next({ invokeNotifySalesTeam: { }, actionName: 'notify-sales', id: id, viewModel: vm, panelId: panelId });
  }
}

/**
 * 
 */
interface IViewModelWebApplication extends IPageDataViewModel {
  data?: { statPanel: any, panels: IWebApplicationViewData[] }

  statPanelVm: IStatViewModel;
  panelsVm: IWebApplicationDataPanelViewModel[];

  actionsAllowed?: boolean;
}

/**
* 
*/
interface IWebApplicationViewData {
  unauthorized: boolean;
  title: string;
  type: string;
  sections: IWebApplicationSectionsViewData[];
}



/**
* 
*/
interface IWebApplicationSectionsViewData extends ICommandElement {
  webAccountApplicationId: number;
  passengerCode: string;
  recomendedCustomer: string;
  matchPassengers: string;
  sendWelcomeEmail: boolean;
  sendSalesTeamEmail: boolean;
  isHomeAddressValid: string;
  isRecomendedCustomer: boolean;
  isDupPassengers: boolean;
  applicationStatus: number;
  messages: string;
  customerCode: string;
  customerName: string;
  firstName: string;
  lastName: string;
  emailAddressPrimary: string;
  companyName: string;
  homeAddressLine1: string;
  homeAddressLine2: string;
  homeCity: string;
  homeStateProvince: string;
  homePostalCode: string;
  homeCountryCode: string;
  specialInstructions: string;
  homePhoneNumber: string;
  mobilePhoneNumber: string;
  submitedCreateDateTime: Date;
  submitedDateTimeString: string;
}

interface ICommandElement {
  cmdExecutingText?: string;
  cmdExecutedErrorText?: string;
  completedText?: string;
}


/**
 * 
 */
interface IWebApplicationDataPanelViewModel {
  data: IWebApplicationViewData;

  title: string;
  type: string;

  sections: IWebApplicationSectionsViewData[];
  sectionsFiltered: IWebApplicationSectionsViewData[];
}

interface IWebApplicationCommand {
  load?: boolean;

  actionName?: string;
  id?: number;
  panelId?: number;

  invokeMarkComplete?: { };
  invokeWelcomeEmail?: { };
  invokeNotifySalesTeam?: { };

  viewModel?: IViewModelWebApplication;
}

interface IWebApplicationCommandResult extends IPageDataViewModel {
  data: { status: string };
}
